import * as types from './actionTypes';
import departureSchedulesApi from '../api/departureSchedulesApi';

export function loadDepartureSchedulesSuccess(departureSchedules) {
  return {type: types.LOAD_DEPARTURE_SCHEDULES_SUCCESS, departureSchedules};
}

export function loadDepartureSchedules(deviceId, authToken) {  
  return function(dispatch) {
    return departureSchedulesApi.getDepartureSchedules(deviceId, authToken).then(departureSchedules => {
      dispatch(loadDepartureSchedulesSuccess(departureSchedules));
    }).catch(error => {
      throw(error);
    });
  };
}

export function createDepartureScheduleSuccess(departureSchedule) {
  return {type: types.CREATE_DEPARTURE_SCHEDULE_SUCCESS, departureSchedule};
}

export function createDepartureSchedule(deviceId, authToken, departureSchedule) {  
  return function(dispatch) {
    return departureSchedulesApi.createDepartureSchedule(deviceId, authToken, departureSchedule).then(responseDepartureSchedule => {
      dispatch(createDepartureScheduleSuccess(responseDepartureSchedule));
	  return responseDepartureSchedule;
    }).catch(error => {
      throw(error);
    });
  };
}

export function updateDepartureScheduleSuccess(departureSchedule) {
  return {type: types.UPDATE_DEPARTURE_SCHEDULE_SUCCESS, departureSchedule};
}

export function updateDepartureSchedule(deviceId, authToken, departureSchedule) {  
  return function(dispatch) {
    return departureSchedulesApi.updateDepartureSchedule(deviceId, authToken, departureSchedule).then(responseDepartureSchedule => {
      dispatch(updateDepartureScheduleSuccess(responseDepartureSchedule));
	  return responseDepartureSchedule;
    }).catch(error => {
      throw(error);
    });
  };
}

export function deleteDepartureScheduleSuccess(departureSchedule) {
  return {type: types.DELETE_DEPARTURE_SCHEDULE_SUCCESS, departureSchedule};
}

export function deleteDepartureSchedule(deviceId, authToken, departureSchedule) {  
  return function(dispatch) {
    return departureSchedulesApi.deleteDepartureSchedule(deviceId, authToken, departureSchedule).then(responseDepartureSchedule => {
      dispatch(deleteDepartureScheduleSuccess(responseDepartureSchedule));
	  return responseDepartureSchedule;
    }).catch(error => {
      throw(error);
    });
  };
}




// WEBPACK FOOTER //
// ./src/actions/departureScheduleActions.js